export const MICROSITES_STATUS_OPTIONS = [
  { string: 'Inactive', enum: 'INACTIVE' },
  { string: 'Live', enum: 'LIVE' },
  { string: 'Ready For Approval', enum: 'READY_FOR_APPROVAL' },
  { string: 'Retired', enum: 'RETIRED' },
  { string: 'Onboarding', enum: 'ONBOARDING' },
];
